import { Injectable } from '@angular/core';
// import { AppVersion } from '@awesome-cordova-plugins/app-version'; // '@awesome-cordova-plugins/app-version/ngx';
import { BatteryStatus, BatteryStatusResponse } from '@awesome-cordova-plugins/battery-status/ngx';
// import { Device } from '@awesome-cordova-plugins/device/ngx';
import { Device } from '@capacitor/device';
import { Platform } from '@ionic/angular';
import { Subject } from 'rxjs';
import { AppInfo } from '../../data/app-info';
import { DeviceInfo } from '../../data/device-info';
import { generateUUID } from '../../globals';
import { MyGolfStorageService } from '../../storage/mygolf-storage.service';
import { App } from '@capacitor/app';
/**
 * Created by ashok on 04/05/17.
 */
@Injectable()
export class DeviceService {
  batteryChange$: Subject<BatteryStatusResponse>;
  batteryLow$: Subject<BatteryStatusResponse>;
  batteryCritical$: Subject<BatteryStatusResponse>;
  deviceInfo: DeviceInfo;
  constructor(private platform: Platform,
    private storage: MyGolfStorageService,
    private battery: BatteryStatus,
    // private appVersion: AppVersion,
    // private device: Device
  ) {
    this.batteryChange$ = new Subject<BatteryStatusResponse>();
    this.batteryLow$ = new Subject<BatteryStatusResponse>();
    this.batteryCritical$ = new Subject<BatteryStatusResponse>();
    if (this.platform.is('mobile')) {//On Mobile Devices
      this.battery.onChange()
        .subscribe((response: BatteryStatusResponse) => this.batteryChange$.next(response));
      this.battery.onLow()
        // .distinctUntilChanged()
        .subscribe((response: BatteryStatusResponse) => this.batteryChange$.next(response));
      this.battery.onCritical()
        // .distinctUntilChanged()
        .subscribe((response: BatteryStatusResponse) => this.batteryChange$.next(response));
    }
    this.getDeviceInfo().then((info: DeviceInfo) => {
      //
      this.deviceInfo = info;
    });

  }
  async getAppInfo(): Promise<AppInfo> {
    if (this.platform.is('capacitor')) {
      return <AppInfo>{
        packageName: (await App.getInfo()).id,
        versionNumber: (await App.getInfo()).version,
        versionCode: (await App.getInfo()).build,
        appName: (await App.getInfo()).name
      };
      // return <AppInfo>{
      //   packageName: await this.appVersion.getPackageName(),
      //   versionNumber: await this.appVersion.getVersionNumber(),
      //   versionCode: await this.appVersion.getVersionCode(),
      //   appName: await this.appVersion.getAppName()
      // };
    }
    else return {};
  }
  async getDeviceInfo(): Promise<DeviceInfo> {
    if (this.platform.is('capacitor')) {
      let _platform = (await Device.getInfo()).platform;
      let _platformVersion = _platform==='android'?((await Device.getInfo()).androidSDKVersion):((await Device.getInfo()).iOSVersion);
      let deviceInfo: DeviceInfo = {
        deviceId: (await Device.getId()).identifier, // this.device.uuid,
        virtual: (await Device.getInfo()).isVirtual, //.device.isVirtual,
        platform: (await Device.getInfo()).platform, //.device.platform,
        platformVersion: String(_platformVersion), //.version,
        model: (await Device.getInfo()).model, //.device.model,
        manufacturer: (await Device.getInfo()).manufacturer, // this.device.manufacturer,
        serial: '-', // this.device.serial,
        cordovaVersion: (await Device.getInfo()).osVersion, //.device.platform
      };
      //
      return deviceInfo;
    }
    else {
      let deviceId: string = await this.storage.preferenceString("mygolf2u.deviceId");
      if (!deviceId) {
        deviceId = generateUUID();
        this.storage.setPreference("mygolf2u.deviceId", deviceId).subscribe(() => {
        });
      }
      return {
        deviceId: deviceId,
        virtual: false,
        platform: (navigator ? navigator.appCodeName : 'browser'),
        manufacturer: (navigator ? navigator.vendor : ''),
        model: (navigator ? navigator.appName : '')
      }
    }
  }
  public getBatteryChange(): Subject<BatteryStatusResponse> {
    return this.batteryChange$;
  }
  public getBatteryLow(): Subject<BatteryStatusResponse> {
    return this.batteryLow$;
  }
  public getBatteryCritical(): Subject<BatteryStatusResponse> {
    return this.batteryCritical$;
  }

  public getCachedDeviceInfo(): DeviceInfo {
    return this.deviceInfo;
  }

}
